var helpers = require('./helpers');

function liveScoringSyncDesktopScoreEntry($input) {
  var $entry = $input.closest('.live-scoring-desktop-score-entry');
  if ($entry.length === 0) return;

  var par = parseInt($input.data('holePar'), 10);
  var value = $input.val();
  if (value !== 'X' && value.indexOf('X') !== -1) {
    value = 'X';
    $input.val('X');
  }

  $entry.attr('data-par-diff', helpers.parDiffForValue(value, par));
}

function liveScoringUpdateDesktopPlayerTotal($row) {
  var total = 0;

  $row.find('.live-scoring-desktop-score-input').each(function () {
    var $input = $(this);
    total += helpers.scoreValueForTotal($input.val(), parseInt($input.data('holePar'), 10));
  });

  $row.find('.live-scoring-desktop-total-value').text(total);
}

function initLiveScoringDesktop($page) {
  if ($page.length === 0) return null;

  helpers.syncFormFieldsForLayout();

  var $inputs = $page.find('.live-scoring-desktop-score-input');

  if ($inputs.length === 0) return null;

  helpers.applyScoreInputMask($inputs);

  $inputs.each(function () {
    var $input = $(this);
    liveScoringSyncDesktopScoreEntry($input);
    liveScoringUpdateDesktopPlayerTotal($input.closest('.live-scoring-desktop-table__player-row'));
  });

  function handleDesktopScoreInput($input) {
    helpers.normalizeInputValue($input);
    liveScoringSyncDesktopScoreEntry($input);
    liveScoringUpdateDesktopPlayerTotal($input.closest('.live-scoring-desktop-table__player-row'));
    window.unsavedChanges = true;
  }

  $page.off('input.liveScoringDesktop', '.live-scoring-desktop-score-input');
  $page.on('input.liveScoringDesktop', '.live-scoring-desktop-score-input', function () {
    handleDesktopScoreInput($(this));
  });

  $page.off('keyup.liveScoringDesktop', '.live-scoring-desktop-score-input');
  $page.on('keyup.liveScoringDesktop', '.live-scoring-desktop-score-input', function () {
    var $input = $(this);
    handleDesktopScoreInput($input);
    helpers.focusNextScoreInput($input);
  });

  $page.off('focus.liveScoringDesktop', '.live-scoring-desktop-score-input');
  $page.on('focus.liveScoringDesktop', '.live-scoring-desktop-score-input', function () {
    $(this).trigger('select');
  });

  return {};
}

function destroyLiveScoringDesktop() {
  var $page = $('.controller-public-hotsites-live-scorings.action-index');

  $page.off('.liveScoringDesktop');

  if (typeof $.fn.unmask === 'function') {
    $page.find('.live-scoring-desktop-score-input').unmask();
  }
}

module.exports = initLiveScoringDesktop;
module.exports.destroy = destroyLiveScoringDesktop;
